import { headerMenuErrors, primaryWebsite, siteSchema, brandFromWebsite, brandProfileSchema, type SiteDocument } from "@twm/shared";
import { demoValidationSite } from "./demo-images";

const key = "kate-demo-sites";
function valid(value: unknown): value is SiteDocument {
  if (!value || typeof value !== "object") return false;
  try { return siteSchema.safeParse(demoValidationSite(value as SiteDocument)).success && (value as SiteDocument).ownerId === "demo-user"; }
  catch { return false; }
}
export function readDemoSites(): SiteDocument[] {
  const stored = localStorage.getItem(key);
  if (stored !== null) {
    try { const list: unknown = JSON.parse(stored); return Array.isArray(list) ? list.filter(valid) : []; }
    catch { return []; }
  }
  // Preserve the original single-website demo without deleting its data.
  try { const legacy: unknown = JSON.parse(localStorage.getItem("twm-demo-site") || "null"); return valid(legacy) ? [legacy] : []; }
  catch { return []; }
}
export function saveDemoSite(site: SiteDocument) {
  const menuError = headerMenuErrors(site)[0]; if (menuError) throw new Error(menuError);
  if (!valid(site)) throw new Error("Check your local website settings before saving.");
  const sites = readDemoSites();
  if (sites.length && !sites.some(other => other.id === site.id)) throw new Error("Each account has one website. Edit your existing website instead.");
  if (sites.some(other => other.id !== site.id && other.slug === site.slug)) throw new Error("Another local website already uses this address.");
  const next = { ...site, updatedAt: new Date().toISOString() };
  const index = sites.findIndex(item => item.id === site.id);
  if (index < 0) sites.push(next);
  else sites[index] = next;
  const previousBrand = localStorage.getItem("twm-demo-brand"), previousSites = localStorage.getItem(key);
  const storedBrand = JSON.parse(previousBrand || "null");
  const nextBrand = storedBrand?.profile ? JSON.stringify({ ...storedBrand, profile: brandFromWebsite(brandProfileSchema.parse(storedBrand.profile), next), updatedAt: next.updatedAt }) : null;
  try {
    if (nextBrand) localStorage.setItem("twm-demo-brand", nextBrand);
    localStorage.setItem(key, JSON.stringify(sites));
  } catch {
    // Keep the previous local website and Brand consistent if the browser is full.
    try {
      if (previousBrand === null) localStorage.removeItem("twm-demo-brand"); else localStorage.setItem("twm-demo-brand", previousBrand);
      if (previousSites === null) localStorage.removeItem(key); else localStorage.setItem(key, previousSites);
    } catch { /* Browser storage is unavailable; no cloud data is involved. */ }
    throw new Error("Browser storage is full. Remove unused local photos or use a smaller image before saving.");
  }
  return next;
}
export function readDemoWebsite() {
  return primaryWebsite(readDemoSites(), localStorage.getItem("kate-demo-primary-site") || undefined);
}
export const demoPreviewUrl = (site: SiteDocument, slug = "") => `/demo/site/${encodeURIComponent(site.id)}${slug ? `/${encodeURIComponent(slug)}` : ""}`;
